import React, { useCallback, useLayoutEffect } from 'react';
import { View } from 'react-native';
import StatusBar from 'design-system/StatusBar';
import ScreenInfoHeader from 'design-system/ScreenInfoHeader';
import IconEmmaWallet from 'design-system/icons/IconEmmaWallet';
import { AppView, SettingsItemNavigate, Spacer } from 'design-system';
import useColors from 'hooks/useColors';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import HelpScreenButton from 'features/help/components/HelpScreenButton';
import { setSelectedTradingAccountId } from '../actions';
import { formatAmount, getTradingAccountName } from '../utils';
import { selectActiveSecclAccounts } from '../reducers/selectors';
const strings = {
    title: 'Where would you like to invest?',
    subtitle: 'Pick one of your investment accounts to continue',
    accountValue: (v) => `Account value ${v}`,
};
const Icon = () => (<>
    <IconEmmaWallet />
    <Spacer.W16 />
  </>);
const StartInvestChooseAccountScreen = ({ navigation }) => {
    const colors = useColors();
    const dispatch = useAppDispatch();
    useLayoutEffect(() => {
        navigation.setOptions({
            headerTintColor: colors.text.primary,
            headerRight: () => <HelpScreenButton />,
        });
    }, [colors.text.primary]);
    const activeSecclAccounts = useAppSelector(selectActiveSecclAccounts);
    const continueToAccount = useCallback((accountId) => () => {
        dispatch(setSelectedTradingAccountId(accountId));
        navigation.navigate('StartInvestChooseStrategy');
    }, []);
    return (<AppView avoidHeader>
      <StatusBar barStyle="dark-content"/>
      <ScreenInfoHeader title={strings.title} subTitle={strings.subtitle}/>
      {activeSecclAccounts?.map(({ account }) => (<TouchableBounceCard key={account.id} onPress={continueToAccount(account.id)} onDark noMarginTop>
          <View pointerEvents="none">
            <SettingsItemNavigate renderIcon={Icon} titleFirst title={getTradingAccountName(account)} description={strings.accountValue(formatAmount(account.availableToInvest))}/>
          </View>
        </TouchableBounceCard>))}
    </AppView>);
};
export default StartInvestChooseAccountScreen;
